import styled from 'styled-components';

export const ChipsWrapper = styled.div`
  padding-left: 16px;
`;
